import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import CoherentScreenMediaReference from './coherent-screen-media-reference-model'
import {
  CreateCoherentScreenMediaReferenceAsync,
  DeleteCoherentScreenMediaReferenceAsync,
  LoadCoherentScreenMediaReferencesAsync,
} from './coherentScreenMediaReference-thunk'
const initialState: coherentScreenMediaReferenceSliceState = {
  coherentScreenMediaReference: [],
  selected_coherentScreenMediaReference: '',
  is_loading_coherentScreenMediaReference: false,
  is_creating_coherentScreenMediaReference: false,
  is_deleting_coherentScreenMediaReference: false,
}
export interface coherentScreenMediaReferenceSliceState {
  coherentScreenMediaReference: CoherentScreenMediaReference[]
  selected_coherentScreenMediaReference?: string
  is_loading_coherentScreenMediaReference: boolean
  is_creating_coherentScreenMediaReference: boolean
  is_deleting_coherentScreenMediaReference: boolean
}
export const coherentScreenMediaReferenceSlice = createSlice({
  name: 'coherentScreenMediaReference',
  initialState,
  reducers: {
    setSelectedcoherentScreenMediaReference: (state, action) => {
      state.selected_coherentScreenMediaReference = action.payload
    },
    clearStatecoherentScreenMediaReference: (state) => {
      state.coherentScreenMediaReference = []
      state.is_loading_coherentScreenMediaReference = false
      state.is_creating_coherentScreenMediaReference = false
      state.is_deleting_coherentScreenMediaReference = false
    },
    mergecoherentScreenMediaReference: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_coherentScreenMediaReference = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.coherentScreenMediaReference = merge(
            state.coherentScreenMediaReference,
            payload,
          ) as any
        }
      }
    },

    add_coherentScreenMediaReference: (state, action) => {
      if (action.payload) {
        state.coherentScreenMediaReference = [
          ...state.coherentScreenMediaReference,
          action.payload,
        ]
      }
    },
    set_coherentScreenMediaReference: (state, action) => {
      let { key, value, id } = action.payload
      state.coherentScreenMediaReference =
        state.coherentScreenMediaReference.map((item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCoherentScreenMediaReferencesAsync.pending, (state) => {
      state.is_loading_coherentScreenMediaReference = true
    })
    builder.addCase(
      LoadCoherentScreenMediaReferencesAsync.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreenMediaReference = false
        if (action.payload) {
          state.coherentScreenMediaReference = action.payload
        }
      },
    )
    builder.addCase(
      LoadCoherentScreenMediaReferencesAsync.rejected,
      (state) => {
        state.is_loading_coherentScreenMediaReference = false
      },
    )
    builder.addCase(
      CreateCoherentScreenMediaReferenceAsync.pending,
      (state) => {
        state.is_creating_coherentScreenMediaReference = true
      },
    )
    builder.addCase(
      CreateCoherentScreenMediaReferenceAsync.fulfilled,
      (state) => {
        state.is_creating_coherentScreenMediaReference = false
      },
    )
    builder.addCase(
      CreateCoherentScreenMediaReferenceAsync.rejected,
      (state) => {
        state.is_creating_coherentScreenMediaReference = false
      },
    )
    builder.addCase(
      DeleteCoherentScreenMediaReferenceAsync.pending,
      (state) => {
        state.is_deleting_coherentScreenMediaReference = true
      },
    )
    builder.addCase(
      DeleteCoherentScreenMediaReferenceAsync.fulfilled,
      (state, action) => {
        state.is_deleting_coherentScreenMediaReference = false
        if (state.coherentScreenMediaReference) {
          state.coherentScreenMediaReference =
            state.coherentScreenMediaReference.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteCoherentScreenMediaReferenceAsync.rejected,
      (state) => {
        state.is_deleting_coherentScreenMediaReference = false
      },
    )
  },
})

export const {
  clearStatecoherentScreenMediaReference,
  setSelectedcoherentScreenMediaReference,
  set_coherentScreenMediaReference,
  mergecoherentScreenMediaReference,
  add_coherentScreenMediaReference,
} = coherentScreenMediaReferenceSlice.actions

export const get_coherentScreenMediaReference =
  (id?: string) =>
  (state: {
    coherentScreenMediaReference: {
      coherentScreenMediaReference: CoherentScreenMediaReference[]
    }
  }): CoherentScreenMediaReference | null => {
    let temp =
      state?.coherentScreenMediaReference?.coherentScreenMediaReference?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.coherentScreenMediaReference?.coherentScreenMediaReference[0] ||
      null
    )
  }
export const get_selected_coherentScreenMediaReference = (state: {
  coherentScreenMediaReference: coherentScreenMediaReferenceSliceState
}): CoherentScreenMediaReference | null => {
  let id =
    state?.coherentScreenMediaReference?.selected_coherentScreenMediaReference
  let temp =
    state?.coherentScreenMediaReference?.coherentScreenMediaReference?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_coherentScreenMediaReference = (state: {
  coherentScreenMediaReference: {
    coherentScreenMediaReference: CoherentScreenMediaReference[]
  }
}): CoherentScreenMediaReference[] => {
  let temp = state?.coherentScreenMediaReference?.coherentScreenMediaReference
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_coherentScreenMediaReference_busy = (state: {
  coherentScreenMediaReference: coherentScreenMediaReferenceSliceState
}) => {
  return (
    state?.coherentScreenMediaReference
      .is_deleting_coherentScreenMediaReference ||
    state?.coherentScreenMediaReference
      .is_loading_coherentScreenMediaReference ||
    state?.coherentScreenMediaReference.is_creating_coherentScreenMediaReference
  )
}
export const is_deleting_coherentScreenMediaReference_busy = (state: {
  coherentScreenMediaReference: coherentScreenMediaReferenceSliceState
}) => {
  return state?.coherentScreenMediaReference
    .is_deleting_coherentScreenMediaReference
}
export const is_loading_coherentScreenMediaReference_busy = (state: {
  coherentScreenMediaReference: coherentScreenMediaReferenceSliceState
}) => {
  return state?.coherentScreenMediaReference
    .is_loading_coherentScreenMediaReference
}
export const is_creating_coherentScreenMediaReference_busy = (state: {
  coherentScreenMediaReference: coherentScreenMediaReferenceSliceState
}) => {
  return state?.coherentScreenMediaReference
    .is_creating_coherentScreenMediaReference
}

export default coherentScreenMediaReferenceSlice.reducer
